import { CheckboxEvent } from "../event";
import { Component, ComponentConfiguration } from "../base";
import { DropdownConfiguration } from "./Dropdown";

export type CheckboxConfiguration = ComponentConfiguration & {
    text?: string,
};

export class Checkbox extends Component
{
    protected configuration: CheckboxConfiguration;

    protected input: HTMLInputElement;

    protected hasChildrenClass: string;

    protected children: NodeListOf<HTMLElement>;

    protected allowChange: boolean;

    protected parent: HTMLElement;


    constructor(...configurations: CheckboxConfiguration[])
    {
        let defaults: CheckboxConfiguration = {
            content_element: ".c-Checkbox__content",
            text: "",
        };

        super(defaults, ...configurations);
    }

    public build(): this
    {
        super.build();

        this.handleRelease = this.handleRelease.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.input = this.querySelector("input");
        this.hasChildrenClass = "c-Checkbox--has-children";

        this.children = null;

        this.allowChange = true;

        this.parent = null;

        this.attachEvents();

        return this;
    }

    public render(): string
    {
        let html = `<div class="c-Field c-Checkbox">
                        <div class="c-Field__input-container">
                            <label class="c-Field__input c-Checkbox__content">
                                <input type="checkbox" />
                                <span class="c-Checkbox__checkmark"></span>
                                <span class="c-Checkbox__text">${this.configuration.text}</span>
                            </label>
                            <div class="c-Field__message"></div>
                        </div>
                    </div>`;

        return html;
    }

    public isChecked(): boolean
    {
        return !!this.input.checked;
    }

    public getInput(): HTMLInputElement
    {
        return this.input;
    }
    public getValue(): boolean
    {
        return this.isChecked();
    }

    public setChecked(checked: boolean = true, options: { silent: boolean } = { silent: false })
    {
        let changed: boolean = checked !== this.isChecked();

        if (!changed)
            return this;

        // this.trigger(CheckboxEvent.BEFORE_CHANGE);
        if (!options.silent)
        {
            this.trigger(CheckboxEvent.BEFORE_CHANGE);
        }

        if (!this.allowChange)
        {
            this.allowChange = true;
            return this;
        }

        this.input.checked = checked;

        this.trigger(CheckboxEvent.AFTER_CHANGE);

        return this;
    }


    public toggleChecked(): this
    {
        this.setChecked(!this.isChecked());
        return this;
    }

    public preventChange(): this
    {
        this.allowChange = false;
        return this;
    }

    protected attachEvents(): this
    {
        // this.addEventListener("click", this.handleRelease);
        this.getInput().addEventListener("change", this.handleInputChange);
        return this;
    }

    protected handleRelease(event): void
    {
        event.stopPropagation();
        event.preventDefault();
        this.toggleChecked();
    }

    protected handleInputChange(event): void
    {
        this.trigger(CheckboxEvent.AFTER_CHANGE);
    }
}
